import gql from 'graphql-tag';
import { BookingsFragmentInclude } from './Bookings';

export default gql`
    fragment EnterMusicians on Funeral {
        EnterMusicians {
            ${BookingsFragmentInclude}
        }
    }
`;
